module.exports = __webpack_public_path__ + "static/enquiries-flipped-ed73473fe177902ca2a26bffe8e52b05.svg";